import { DownArrowLong, ArrowForward } from '@carvana/icons';
import { cvBreakpoint768 } from '@carvana/theme';
import styled, { css } from 'styled-components';

export const SvgIcon = css`
  & > svg {
    width: 12px;
    height: 12px;
  }
`;

export const TypeWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  cursor: pointer;
  &:not(:last-of-type) {
    border-bottom: 1px solid ${props => props.theme.carvana.gray.light};
  }
`;

export const ContentWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-basis: 100%;
  height: auto;
  justify-content: space-between;
  padding-bottom: 18px;
  padding-top: 18px;
`;

export const LeftContent = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
`;

export const RightContent = styled.div`
  cursor: pointer;
  justify-content: space-between;
  display: flex;
  margin-left: 16px;
  align-items: start;
  height: ${props => props.isStaticHeight ? '60px' : '100%'};

  @media (min-width: ${cvBreakpoint768}px) {
    height: 60px;
    align-items: center;
    margin-left: 32px;
  }
`;

export const IconWrapper = styled.div`
  padding-right: 20px;
`;

export const TypeContent = styled.div`

`;

export const TitleBadgeWrapper = styled.div`
  flex-direction: column;
  align-items: start;
  display: flex;
  @media (min-width: ${cvBreakpoint768}px) {
    align-items: center;
    flex-direction: row;
  }
`;

export const TypeTitle = styled.p`
  color: ${props => props.isGreyedOut ? props.theme.carvana.gray.medium : props.theme.carvana.blue.dark};
  font-weight: bold;
  margin-bottom: 4px;
`;

export const TypeSubtitle = styled.p`
  color: ${props => props.theme.carvana.gray.dark};
  font-size: 14px;
`;

export const LinkArrow = styled(DownArrowLong)`
  ${SvgIcon};
  transform: rotate(180deg);
  color: ${props => props.theme.carvana.blue.primary};
`;

export const LinkContent = styled.div`
  padding: 29px 0 0 5px;
  color: ${props => props.theme.carvana.blue.primary};
`;

export const buttonStyles = css`
  align-self: center;
  width: 90px;
  min-height: 40px;
  min-width: 80px;

  @media (min-width: ${cvBreakpoint768}px) {
    width: 106px;
  }
`;

export const RightContentItem = styled.div`
  font-weight: 500;
  color: ${props => props.theme.carvana.blue.primary};
  text-align: center;
`;

export const DetailsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-basis: 100%;
  margin: -10px 0 16px 60px;
`;

export const Details = styled.ul`
  color: #757989;
  line-height: 32px;
  margin: 0 0 0 -20px;

  @media (min-width: ${cvBreakpoint768}px) {
    margin: 0px;
  }
`;

export const ExpandArrow = styled(ArrowForward)`
  ${SvgIcon}
  margin-left: 16px;
  transform: ${props => props.expanded ? 'rotate(270deg)' : 'rotate(90deg)'}
`;

export const Badge = styled.div`
  align-items: left;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  margin-left: 10px;
  background-color: #EBFBEE;
  padding: 5px 8px;
  border-radius: 2px;
  color: #237032;
  font-size: 12px;
`;

export const UploadedBadge = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #EBFBEE;
  padding: 5px 8px;
  border-radius: 2px;
  color: #237032;
  font-size: 12px;
  margin-left: 0px;
  margin-bottom: 5px;
  @media (min-width: ${cvBreakpoint768}px) {
    margin-left: 10px;
  }
`
